module.exports = __webpack_public_path__ + "img/94284b2.png";